import { forEach, keys } from 'ramda';

import { RawMessagesType } from 'components/IntlProvider';

export const parseTranslation = (rawMessages: RawMessagesType) => {
  const parsedMessages: { [key: string]: string } = {};

  forEach((translationKey: string) => {
    if (translationKey.length === 0) return;
    parsedMessages[translationKey] = rawMessages[translationKey][1];
  }, keys(rawMessages));

  return parsedMessages;
};

export const parseDataTable = (value: string | null) => {
  if (typeof value === 'string') {
    return value.length === 0 ? '-' : value;
  }

  return value || '-';
};
